import type { SwipeDirection } from '../types';


/**
 * Returns `true` when `delta` surpasses `threshold` in the given direction.
 *
 * @param delta - Signed pixel delta along the swipe axis.
 * @param direction - The swipe direction.
 * @param threshold - Minimum distance in pixels to activate the trigger.
 * @returns Whether the swipe threshold has been exceeded.
 */
export const isExceededThreshold = (
    delta: number,
    direction: SwipeDirection,
    threshold: number,
): boolean => {
    if (direction === 'left') {
        return delta < -threshold;
    }
    if (direction === 'right') {
        return delta > threshold;
    }
    if (direction === 'up') {
        return delta < -threshold;
    }
    if (direction === 'down') {
        return delta > threshold;
    }

    return false;
}
